export const PERFORMANCE_MONITOR_PARAMS = [
  'id',

  'first_render_duration',
  'last_render_duration',
  'shortest_render_duration',
  'longest_render_duration',
  'average_render_duration',
  'render_count',

  'first_track_duration',
  'last_track_duration',
  'shortest_track_duration',
  'longest_track_duration',
  'average_track_duration',
  'track_count',

  'start_reason',
  'stop_reason',

  'time_to_network_duration_exclusive',
  'time_to_network_duration_inclusive',

  'data',
] as const;

export type PerformanceMonitorParams = Record<
  (typeof PERFORMANCE_MONITOR_PARAMS)[number],
  unknown
>;
